'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = toExternalType;

var _utils = require('./utils');

var _toApiExternalType = require('./toApiExternalType');

var _toApiExternalType2 = _interopRequireDefault(_toApiExternalType);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getParser(singleConfig) {
  return !singleConfig || !singleConfig.url ? function (actionType) {
    return actionType;
  } : _toApiExternalType2.default;
}

function toExternalType(config, actionTypes) {
  return Object.keys(actionTypes).reduce(function (acc, key) {
    var _extends2;

    var parse = getParser(config[key]);
    return _extends({}, acc, (_extends2 = {}, _extends2[(0, _utils.parseToUppercase)(key)] = parse(actionTypes[key]), _extends2));
  }, {});
}